export const CONTACT_URL ="https://api.jumbly.org/api/enquiry"